<template>
    <div
        class="wizard wizard-2 dm-submission-wizard-navigation"
        v-if="isGenresStepDone"
    >
        <div class="wizard-nav border-bottom">
            <div class="wizard-steps dm-wizard-steps arrow-steps">
                <TopNavigationStep
                    v-for="step_data in navigation_steps_desktop"
                    :step_data="step_data"
                    :key="'navigation-step-' + step_data.slug"
                />
            </div>
        </div>
    </div>
</template>

<script>
import TopNavigationStep from "./partials/TopNavigationStep.vue";
import { useSubmissionWizardStore } from "@storesSw/SubmissionWizardStore";
import { mapState } from "pinia";

export default {
    components: { TopNavigationStep },

    computed: {
        ...mapState(useSubmissionWizardStore, ["navigation_steps_desktop"]),

        isGenresStepDone() {
            return this.navigation_steps_desktop && this.navigation_steps_desktop[0] && this.navigation_steps_desktop[0]['is_done'] == true;
        }
    },

    methods: {
        scrollToStepOnMobile() {
            if (!this.isGenresStepDone) return;

            $(".wizard-nav").animate(
                {
                    scrollLeft: $(
                        '.dm-wizard-steps div[data-wizard-state="current"]',
                    ).position().left,
                },
                500,
            );
        },
    },

    updated() {
        this.scrollToStepOnMobile();
    },
};
</script>
